import React from 'react';

const AboutCourse = () => {
  return (
    <section className="about-course">
      <div className="container">
        <h2 className="section-title">SOBRE O CURSO</h2>
        <div className="section-divider"></div>
        
        <div className="about-content">
          <div className="about-text">
            <p>
              O <strong>Curso Expert em Henna</strong> é um treinamento completo, desenvolvido para você dominar a técnica de aplicação de henna em sobrancelhas de forma profissional.
            </p>
            <p>
              Com mais de <strong>20 aulas práticas</strong>, você vai aprender desde os fundamentos até técnicas avançadas de aplicação, com um método simples e comprovado que já transformou a carreira de milhares de profissionais.
            </p>
            <p>
              O curso é 100% online, com acesso por 1 ano, para você estudar no seu ritmo e revisar quantas vezes quiser.
            </p>
          </div>
          
          <div className="about-highlights">
            <div className="highlight-item">
              <span className="highlight-text">100% Online</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-text">Certificado Incluso</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-text">Acesso por 1 Ano</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-text">Suporte Direto</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCourse;
